import { render, staticRenderFns } from "./petsInfo.vue?vue&type=template&id=1558223b&scoped=true&"
import script from "./petsInfo.vue?vue&type=script&lang=js&"
export * from "./petsInfo.vue?vue&type=script&lang=js&"
import style0 from "./petsInfo.vue?vue&type=style&index=0&id=1558223b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1558223b",
  null
  
)

export default component.exports